import _extends from '@babel/runtime/helpers/extends';
import { __rest } from '../../../dependencies/tslib/tslib.es6.js';
import React__default from 'react';
import { iconSize } from '../../../utils/helpers.js';

/* eslint-disable max-len */

var RefundMoney = (function (_a) {
  var _a$size = _a.size,
      size = _a$size === void 0 ? 'xs' : _a$size,
      props = __rest(_a, ["size"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({}, props, {
    width: iconSize[size],
    height: iconSize[size],
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M22.1754 18.5885H19.7213V15.9001H22.1754C22.9575 15.9001 23.582 16.5263 23.582 17.2443C23.582 17.9623 22.9575 18.5885 22.1754 18.5885Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5 20.0005C31.5 26.0756 26.5751 31.0005 20.5 31.0005C14.4249 31.0005 9.5 26.0756 9.5 20.0005C9.5 13.9254 14.4249 9.00049 20.5 9.00049C26.5751 9.00049 31.5 13.9254 31.5 20.0005ZM18.8213 14.1001H22.1754C23.887 14.1001 25.382 15.4688 25.382 17.2443C25.382 19.0199 23.887 20.3885 22.1754 20.3885H19.7213V22.0278H21.8637C22.3608 22.0278 22.7637 22.4308 22.7637 22.9278C22.7637 23.4249 22.3608 23.8278 21.8637 23.8278H19.7213V25.5698C19.7213 26.0668 19.3183 26.4698 18.8213 26.4698C18.3242 26.4698 17.9213 26.0668 17.9213 25.5698V23.8278H17.5C17.0029 23.8278 16.6 23.4249 16.6 22.9278C16.6 22.4308 17.0029 22.0278 17.5 22.0278H17.9213V20.3885H17.5C17.0029 20.3885 16.6 19.9856 16.6 19.4885C16.6 18.9915 17.0029 18.5885 17.5 18.5885H17.9213V15.0121L17.9212 15.0001C17.9212 14.503 18.3242 14.1001 18.8213 14.1001Z",
    fill: "currentColor"
  }));
});

export { RefundMoney as default };
